import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  loader: ({ width, height, borderWidth, margin }) => ({
    width,
    height,
    '&::after': {
      width,
      height,
      margin,
      borderWidth,
    },
  }),
}));

function LoadingSpinner({ styles }) {
  const classes = useStyles(styles);
  return <div className={['lds-dual-ring', classes.loader].join(' ')} />;
}

export default LoadingSpinner;
